export const MOBILE_BREAKPOINT = 601;
export const NAV_PRIMARY_HEIGHT = 56;
export const NAV_SECONDARY_HEIGHT = 84;
export const NAV_ADMIN_SUITE_HEIGHT = 72;
export const NAV_ADMIN_SUITE_SECONDARY_HEIGHT = 90;
export const NAV_TOTAL_HEIGHT = NAV_PRIMARY_HEIGHT + NAV_SECONDARY_HEIGHT;
export const NAV_PRIMARY_MOBILE_HEIGHT = 40;
export const NAV_SECONDARY_MOBILE_HEIGHT = 56;
/* The nav list in secondary desktop isn't centered, it is 16px down from the top */
export const NAV_SECONDARY_TOP_PADDING = 16;
